import Actions from './page-template-actions';
import Api from './page-template-api';
import Collection from './page-template-collection';
import Model from './page-template-model';
import reducer from './page-template-reducer';
import Selectors from './page-template-selectors';
import sagas from './page-template-sagas';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'pageTemplate',
  reducer,
  sagas: [sagas],
  Selectors,
};
